/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationResourceDetailsRequest extends models.ScheduleRecommendationDetailsBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationResourceDetailsRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationResourceDetailsRequest>): ScheduleRecommendationResourceDetailsRequest {
        let obj = Object.assign(new ScheduleRecommendationResourceDetailsRequest(), model);
        ScheduleRecommendationResourceDetailsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationResourceDetailsRequest>): ScheduleRecommendationResourceDetailsRequest {
        if (!model) return null;
        return ScheduleRecommendationResourceDetailsRequest.newInstance(<ScheduleRecommendationResourceDetailsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationResourceDetailsRequest) {
        if (!obj) return;

        models.ScheduleRecommendationResourceDetailsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationResourceDetailsRequest): boolean {
        if (models.ScheduleRecommendationDetailsBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationResourceDetailsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
